// src/components/Footer.js
import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer>
      <p>Copyright ® Huyser Industries. All Rrights Reserved.</p>
    </footer>
  );
}

export default Footer;
